document.addEventListener("DOMContentLoaded", initCollectionLoadMore);
document.addEventListener("collection:updated", initCollectionLoadMore);
function initCollectionLoadMore() {
  const grid = document.querySelector("#CollectionLoop");
  if (!grid) return;
  const button = document.querySelector("#CollectionLoadMore");
  if (!button) return;
  const PRODUCTS_PER_CLICK = 16;
  const items = [...grid.querySelectorAll(".grid-item")];
  const products = items.filter(item =>
    !item.classList.contains("product-item--featured-image")
  );
  let visibleProducts = PRODUCTS_PER_CLICK;
  update();
  button.onclick = function () {
    visibleProducts += PRODUCTS_PER_CLICK;
    update();
  };
  function update() {
    let shownProducts = 0;
    items.forEach(item => {
      if (item.classList.contains("product-item--featured-image")) {
        item.style.display = "";
        return;
      }
      shownProducts++;
      if (shownProducts <= visibleProducts) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
    if (visibleProducts >= products.length) {
      button.disabled = true;
    } else {
      button.disabled = false;
    }
  }
}